import clsx from "clsx";
import Button from "~/shared/ui/Fields/Button";
import s from "./StaffTrainingControl.module.less";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "~/shared/context/PermissionContext";

interface IStaffTrainingControlProps {
  getStaffReports: () => void;
  handleModal: () => void;
  goStaffBonus: () => void;
  goStaffTraining: () => void;
  disabledControl?: boolean;
}

export const StaffControl = (props: IStaffTrainingControlProps) => {
  const { t } = useTranslation();

  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const { getStaffReports, handleModal, goStaffBonus, goStaffTraining } = props;

  return (
    <div className={s.staffControlRow}>
      {hasPermission("employeeAccounting.statistics.bonus.report.save") && (
        <Button
          txtBtn={t("q.save_excel")}
          small
          green
          customClassName={clsx(s.btn_center, s.correct_margin)}
          onClick={getStaffReports}
        />
      )}
      {hasPermission("employeeAccounting.statistics.report.get") && (
        <Button
          txtBtn={"выбор должности"}
          small
          green
          customClassName={clsx(s.btn_center, s.correct_margin)}
          onClick={handleModal}
        />
      )}
      {hasPermission("employeeAccounting.statistics.bonus.report.get") && (
        <Button
          txtBtn={"Малус по обучению"}
          small
          green
          customClassName={clsx(s.btn_center, s.correct_margin)}
          onClick={goStaffBonus}
        />
      )}
      <Button
        txtBtn={"Обученность"}
        small
        green
        customClassName={clsx(s.btn_center, s.correct_margin)}
        onClick={goStaffTraining}
      />
    </div>
  );
};
